import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/grid';
import 'swiper/css/effect-cube';
import 'lightgallery/css/lightgallery-bundle.css';
import 'lightgallery/css/lightgallery.css';
import "./assets/styles/app.scss";

if (module.hot) {
  module.hot.accept();
}

document.addEventListener("DOMContentLoaded", function() {
  // Выбираем все изображения на странице
  const images = document.querySelectorAll('.hero__bg img:not([src$=".svg"])');

  // Добавляем класс blur ко всем изображениям
  images.forEach(img => {
      img.classList.add('blur');

      // Удаляем класс blur с задержкой, когда изображение полностью загружено
      img.onload = () => {
        img.classList.remove('blur');
      };

      // Для уже кэшированных и загруженных изображений
      if (img.complete) {
        img.classList.remove('blur');
      }
  });

  // Обработчик события прокрутки
  window.addEventListener('scroll', function() {
      images.forEach(img => {
          if (img.complete && isElementInViewport(img)) {
            img.classList.remove('blur');
          }
      });
  });

  // Функция для проверки, видим ли элемент на экране
  function isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
  }
});

$(function () {
  require("js/app");
});